<template>
  <div class="circle-item">
    <div class="circle-item-top">
      <img :src="'data:image/png;base64,'+item.user.headimgBase64">
      <div class="temp1">
        <div class="info" @click="gotoDetail">
          <div class="goods-info">
            <div class="title">{{typeTitle}}{{level}}{{item.title}}</div>
            <div class="price" v-if="item.feeType==1 && item.price && item.price>0">￥{{item.price}}元</div>
            <div class="price" v-else-if="item.feeType==2">面议</div>
          </div>
          <div class="user-info">
            {{item.user.nickname}}
            <i class="iconfont icon-nan2 nan" v-if="item.user.sex==1"></i>
            <i class="iconfont icon-nv2 nv" v-else></i>
            {{createTime}}前发布
          </div>
        </div>
        <div class="content" @click="gotoDetail" v-if="item.remark || item.remark || pics.length>0">
          <div class="imgs" v-if="pics.length > 0">
            <div class="img-item">
              <img :name="item._id+'img'" v-if="pics[0]" :src="pics[0].url">
            </div>
            <div class="img-item">
              <img :name="item._id+'img'" v-if="pics[1]" :src="pics[1].url">
            </div>
            <div class="img-item">
              <img :name="item._id+'img'" v-if="pics[2]" :src="pics[2].url">
            </div>
          </div>
          <div class="remark" v-if="item.remark" v-html="item.remark"></div>
          <div class="demand" v-if="item.demand">
            <span class="deman-span">要求</span>
            {{item.demand}}
          </div>
        </div>
        <div class="other-info" @click="gotoDetail">
          <div class="sum">
            <span v-if="item.sum >= 0">剩余{{item.sum}}件</span>
            <span v-else>无数量限制</span>
          </div>
          <div class="viewzan">
            <div class="other-info-item">
              <i class="iconfont icon-liulan"></i>
              <span>{{item.view}}人</span>
            </div>
            <div class="other-info-item">
              <i class="iconfont icon-dianzan"></i>
              <span>{{item.zan}}人</span>
            </div>
          </div>
        </div>
        <div class="handle" v-if="handle">
          <div class="status">
            <span class="status-up" v-if="item.status == 1">已上架</span>
            <span class="status-down" v-else>已下架</span>
          </div>
          <div class="handle-bnt">
            <div class="handle-bnt-item bnt-edit" @click="edit">编辑</div>
            <div class="handle-bnt-item bnt-down" v-if="item.status == 1" @click="setStatus(0)">下架</div>
            <div class="handle-bnt-item bnt-up" v-else @click="setStatus(1)">上架</div>
            <div class="handle-bnt-item bnt-del" @click="del">删除</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import moment from "moment";
import axios from "axios";

export default {
  props: {
    item: Object,
    token: String,
    handle: Boolean
  },
  data() {
    return {
      typeTitle: null,
      level: null,
      createTime: null,
      pics: [],
      defaultCover: null
    };
  },
  created() {
    let du = moment.duration(moment() - moment(this.item.createdAt), "ms");
    this.createTime = du.locale("zh-cn").humanize();

    if(this.item.remark) {
      this.item.remark = this.item.remark.replace(/\n/g, "<br/>");
    }

    if (this.item.bizType == 10) {
      this.typeTitle = "想买";
      if (this.item.goodsType == 10) {
        this.defaultCover = "/static/gt-2-200x200.png";
      } else {
        this.defaultCover = "/static/gt-4-200x200.png";
      }
    } else if (this.item.bizType == 20) {
      this.typeTitle = "出售";
      if (this.item.goodsType == 10) {
        this.defaultCover = "/static/gt-1-200x200.png";
      } else {
        this.defaultCover = "/static/gt-3-200x200.png";
      }
    } else if (this.item.bizType == 30) {
      this.typeTitle = "想租";
      this.defaultCover = "/static/gt-5-200x200.png";
    } else if (this.item.bizType == 40) {
      this.typeTitle = "出租";
      this.defaultCover = "/static/gt-6-200x200.png";
    } else if (this.item.bizType == 50) {
      this.typeTitle = "想借";
      this.defaultCover = "/static/gt-7-200x200.png";
    } else if (this.item.bizType == 60) {
      this.typeTitle = "出借";
      this.defaultCover = "/static/gt-8-200x200.png";
    } else if (this.item.bizType == 70) {
      this.typeTitle = "我能";
      this.defaultCover = "/static/gt-9-200x200.png";
    }

    if (this.item.level == 100) {
      this.level = "全新";
    } else if (this.item.level == 99) {
      this.level = "99新";
    } else if (this.item.level == 90) {
      this.level = "9成新";
    } else if (this.item.level == 80) {
      this.level = "8成新";
    } else if (this.item.level == 70) {
      this.level = "7成新";
    } else if (this.item.level == 60) {
      this.level = "6成新";
    } else if (this.item.level == 50) {
      this.level = "5成新";
    } else if (this.item.level == 40) {
      this.level = "4成新";
    } else if (this.item.level == 30) {
      this.level = "3成新";
    } else if (this.item.level == 20) {
      this.level = "2成新";
    } else if (this.item.level == 10) {
      this.level = "1成新";
    }

    if (this.item.pics.length == 0) {
      this.pics.push({ url: this.defaultCover });
    } else {
      for (let i = 0; i < this.item.pics.length; i++) {
        if (i < 3) {
          this.pics.push(this.item.pics[i]);
        } else {
          break;
        }
      }
    }
  },
  methods: {
    gotoDetail() {
      this.$router.push("/circleDetail/" + this.item._id + "/" + this.token);
    },
    setStatus(status) {
      let title = "确定上架？";
      if (status == 0) {
        title = "确定下架？";
      }
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: title,
        confirmBtn: {
          text: "确 定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取 消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          axios
            .put("/api/circle/status/" + this.item._id + "/" + status)
            .then(res => {
              if (res.data.success) {
                weui.toast("操作成功", 500);
                this.item.status = status;
                this.$emit("requery");
              } else {
                weui.alert("操作失败", 500);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }).show();
    },
    del() {
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "确定删除该数据？",
        confirmBtn: {
          text: "确 定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取 消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          axios
            .delete("/api/circle/" + this.item._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("操作成功", 500);
                this.$emit("requery");
              } else {
                weui.alert("操作失败", 500);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }).show();
    },
    edit() {
      this.$router.push(
        "/circleEdit/" +
          this.item.bizType +
          "/" +
          this.item.goodsType +
          "/" +
          this.item._id +
          "/" +
          this.token
      );
    }
  },
  mounted() {
    let images = document.getElementsByName(this.item._id + "img");
    let height = parseInt((document.body.clientWidth - 90) / 3);
    for (let i = 0; i < images.length; i++) {
      let img = images[i];
      img.style.height = height + "px";
    }
  }
};
</script>

<style scoped>
.nan {
  color: #296aed;
  font-weight: bold;
}
.nv {
  color: #ec73bb;
  font-weight: bold;
}
.circle-item {
  padding: 10px 10px 0px 10px;
  border-bottom: 1px solid #bdccd4;
}
.circle-item-top {
  display: flex;
}
.circle-item-top > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.temp1 {
  width: 100%;
}
.info {
  width: 100%;
  padding-bottom: 5px;
  border-bottom: 1px solid #efefef;
}
.goods-info {
  display: flex;
  width: 100%;
}
.goods-info .title {
  flex: 1;
  font-size: 16px;
  margin-left: 10px;
}
.goods-info .price {
  font-size: 16px;
  text-align: right;
  color: red;
}
.user-info {
  margin-left: 10px;
  font-size: 10px;
}
.user-info i {
  font-size: 10px;
}
.content {
  width: 100%;
  padding-bottom: 5px;
  border-bottom: 1px solid #efefef;
}
.content .imgs {
  display: flex;
  margin: 10px 0px 10px 10px;
}
.imgs div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-item + .img-item {
  margin-left: 5px;
}
.imgs > div > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content .remark {
  padding-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  max-height: 66px;
  overflow-y: hidden;
}
.content .demand {
  padding-left: 10px;
  margin-top: 5px;
}
.deman-span {
  background-color: #ff1e48;
  color: #ffffff;
  padding: 2px 4px;
  margin-right: 5px;
}
.other-info {
  display: flex;
  margin-top: 3px;
  margin-bottom: 3px;
}
.sum {
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #fda800;
}
.viewzan {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.other-info-item + .other-info-item {
  margin-left: 10px;
}
.handle {
  display: flex;
  padding-top: 8px;
  margin-bottom: 8px;
  border-top: 1px solid #efefef;
}
.status {
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.status-up {
  background-color: #179b16;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
}
.status-down {
  background-color: #ff1e48;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
}
.handle-bnt {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.handle-bnt-item + .handle-bnt-item {
  margin-left: 10px;
}
.bnt-down {
  background-color: #299cdf;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 10px;
  min-width: 32px;
  text-align: center;
}
.bnt-up {
  background-color: #179b16;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 10px;
  min-width: 32px;
  text-align: center;
}
.bnt-del {
  background-color: #ff1e48;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 10px;
  min-width: 32px;
  text-align: center;
}
.bnt-edit {
  background-color: #fda800;
  color: #ffffff;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 10px;
  min-width: 32px;
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/components/common/CircleItem.vue